import { useReducer } from 'react';
import { AlertInitalState, AlertReducer } from '../hooks/useAlert';

export const HomeInitalState = {
    ccd: '',
    loggedUser: {
        companyCode: '',
        fullName: "",
        userId: 0,
        isUserLogged: false,
        ccd: '',
        photoId: -1,
        photoBytes: null,
        sessionCode: '',
        objectRights: []
    },
    nurseSearchText: '',
    patientServiceSearchText: '',
    bookingSearchText: '',
    employeeSearchText: '',
    religions: [],
};

export const HomeReducer = (state = HomeInitalState, action) => {
    let tempLoggedUser = { ...state.loggedUser };

    switch (action.type) {
        case "SET_LOGGED_USER":
            tempLoggedUser.companyCode = (action.payload.companyCode ?? '').toLowerCase();
            tempLoggedUser.userId = action.payload.userId;
            tempLoggedUser.fullName = action.payload.fullName;
            tempLoggedUser.ccd = action.payload.ccd;
            tempLoggedUser.photoId = action.payload.photoId;
            tempLoggedUser.sessionCode = action.payload.sessionCode;
            tempLoggedUser.objectRights = [...action.payload.objectRights];
            tempLoggedUser.isUserLogged = true;

            return {
                ...state,
                loggedUser: { ...tempLoggedUser }
            }

        case "CLEAR_LOGGED_USER":
            tempLoggedUser.companyCode = "";
            tempLoggedUser.userId = 0;
            tempLoggedUser.fullName = "";
            tempLoggedUser.photoId = -1;
            tempLoggedUser.photoBytes = null;
            tempLoggedUser.sessionCode = '';
            tempLoggedUser.objectRights = [];
            tempLoggedUser.isUserLogged = false;

            return {
                ...state,
                loggedUser: { ...tempLoggedUser }
            }

        case "SET_NURSE_SEARCH_TEXT":
            return {
                ...state,
                nurseSearchText: action.payload.searchText
            }

        case "SET_PATIENT_SERVICE_SEARCH_TEXT":
            return {
                ...state,
                patientServiceSearchText: action.payload.searchText
            }

        case "SET_BOOKING_SEARCH_TEXT":
            return {
                ...state,
                bookingSearchText: action.payload.searchText
            }

        case "SET_LOGGED_USER_PHOTO":
            tempLoggedUser.photoBytes = action.payload.dbPhoto;
            return {
                ...state,
                loggedUser: { ...tempLoggedUser }
            }

        case "SET_EMPLOYEE_SEARCH_TEXT":
            return {
                ...state,
                employeeSearchText: action.payload.searchText
            }

        case "SET_RELIGIONS":
            return {
                ...state,
                religions: action.payload.religions
            }

        case "SET_CCD":
            return {
                ...state,
                ccd: action.payload.ccd
            }

        default:
            return { ...state };

    }
}


export const useHome = () => {
    const [alertState, dispatchAlert] = useReducer(AlertReducer, AlertInitalState);
    const [homeState, dispatchHome] = useReducer(HomeReducer, HomeInitalState);

    const OpenSuccessAlert = (message) => {
        dispatchAlert({
            type: "OPEN_SUCCESS_ALERT",
            payload: {
                message: message
            }
        })
    }

    const OpenErrorAlert = (error) => {

        let errorMsg = '';

        if (typeof error === "string") {
            errorMsg = error;
        } else if (typeof error === "object") {
            errorMsg = error.message ? error.message : error.toString();
        }
        dispatchAlert({
            type: "OPEN_ERROR_ALERT",
            payload: {
                message: errorMsg
            }
        })
    }

    const CloseAllAlerts = () => {
        dispatchAlert({
            type: "CLOSE_ALERT",
            payload: null
        })
    }

    const SetLoggedUser = (companyCode, userId, userFullName, photoId, ccd, sessionCode, objectRights) => {
        dispatchHome({
            type: "SET_LOGGED_USER",
            payload: {
                companyCode: companyCode,
                userId: userId,
                fullName: userFullName,
                photoId: photoId,
                ccd: ccd,
                sessionCode: sessionCode,
                objectRights: [...objectRights]
            }
        })
    }

    const ClearLoggedUser = () => {
        dispatchHome({
            type: "CLEAR_LOGGED_USER",
            payload: {
                companyCode: '',
                userId: 0,
                fullName: 0,
                photoId: -1,
                sessionCode: ''
            }
        })
    }

    const ShowAPIError = async (response) => {
        const tempJson = await response.json();
        if (tempJson && (tempJson.message || tempJson.error)) {
            OpenErrorAlert(tempJson.message ?? tempJson.error)
        }
    }

    const SetNurseSearchText = (searchText) => {
        dispatchHome({
            type: "SET_NURSE_SEARCH_TEXT",
            payload: {
                searchText: searchText
            }
        })
    }

    const SetPatientServiceSearchText = (searchText) => {
        dispatchHome({
            type: "SET_PATIENT_SERVICE_SEARCH_TEXT",
            payload: {
                searchText: searchText
            }
        })
    }

    const SetBookingSearchText = (searchText) => {
        dispatchHome({
            type: "SET_BOOKING_SEARCH_TEXT",
            payload: {
                searchText: searchText
            }
        })
    }

    const SetAccountPersonIcon = (dbPhoto) => {
        dispatchHome({
            type: "SET_LOGGED_USER_PHOTO",
            payload: {
                dbPhoto: dbPhoto
            }
        })
    }

    const SetEmployeeSearchText = (searchText) => {
        dispatchHome({
            type: "SET_EMPLOYEE_SEARCH_TEXT",
            payload: {
                searchText: searchText
            }
        })
    }

    const SetReligions = (religions) => {
        dispatchHome({
            type: "SET_RELIGIONS",
            payload: {
                religions: religions
            }
        })
    }

    const SetHomeCCD = (ccd) => {
        dispatchHome({
            type: "SET_CCD",
            payload: {
                ccd: ccd
            }
        })
    }


    return {
        alertState,
        homeState,
        OpenSuccessAlert,
        OpenErrorAlert,
        CloseAllAlerts,
        ShowAPIError,
        SetLoggedUser,
        ClearLoggedUser,
        SetNurseSearchText,
        SetPatientServiceSearchText,
        SetBookingSearchText,
        SetAccountPersonIcon,
        SetEmployeeSearchText,
        SetReligions,
        SetHomeCCD
    }
}